/** API /api/admin/:code vastaus – kentät voivat olla null, booleanit tulkitaan null → false */
export interface AdminPerson {
    id: string;
    firstname: string | null;
    lastname: string | null;
    phone: string | null;
    email: string | null;
    parentName: string | null;
    parentPhone: string | null;
    devicePc: boolean | null;
    deviceConsole: boolean | null;
    deviceHanging: boolean | null;
    deviceOther: boolean | null;
    deviceOtherComment: string | null;
    attendingThu: boolean | null;
    attendingFri: boolean | null;
    tournamentBS: boolean | null;
    tournamentOW: boolean | null;
    tournamentLOL: boolean | null;
    tournamentMC: boolean | null;
    tournamentCS: boolean | null;
    tournamentTetris: boolean | null;
    tournamentTableTennis: boolean | null;
    tournamentOther: boolean | null;
    tournamentOtherComment: string | null;
    food: boolean | null;
    diet: boolean | null;
    dietL: boolean | null;
    dietG: boolean | null;
    dietV: boolean | null;
    dietOther: boolean | null;
    dietOtherComment: string | null;
    history: string | null;
    arrived: number | null;
    food_paid: number | null;
    staff_food: number | null;
    staff_price: number | null;
    Location: string | null;
}

export function asBoolean(value: boolean | null | undefined): boolean {
    return value === true;
}

export function asString(value: string | null | undefined): string {
    return value ?? '';
}
